export default __webpack_public_path__ + "static/media/lonestar-bg.ff1aecc7.jpg";